<template>
  <el-dialog
    custom-class="resetPasswordDialog"
    destroy-on-close
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-alert
      :title="$l('INDEX.alter_title_resetPassword') || '重置密码'"
      :description="
        $l('INDEX.alter_desc_resetPassword') ||
          '当前密码过于简单或依然为初始密码，请重置密码后重新登录'
      "
      type="warning"
      class="resetPasswordDialog-alert"
      show-icon
      :closable="false"
    />
    <RestPasswordForm ref="resetPasswordForm" :userCode="userCode" />
    <div slot="footer" class="dialog-footer">
      <el-button type="success" :loading="confirmLoading" @click="confrim">{{
        $l('INDEX.btn_resetPassword_confirm') || '确 定'
      }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import RestPasswordForm from './form'
export default {
  components: { RestPasswordForm },
  props: {
    visible: { type: Boolean },
    userCode: { type: String, default: '' }
  },
  data() {
    return {
      confirmLoading: false
    }
  },
  methods: {
    confrim() {
      this.confirmLoading = true
      this.$refs.resetPasswordForm
        .submit()
        .then(() => {
          this.confirmLoading = false
          this.$emit('update:visible', false)
        })
        .catch(() => {
          this.confirmLoading = false
        })
    }
  }
}
</script>
<style lang="scss">
.resetPasswordDialog {
  width: 455px !important;
  .el-dialog__header {
    padding: 0 !important;
  }
  .resetPasswordDialog-alert {
    margin: 15px 0 15px 0;
  }
}
</style>
